// extracted by mini-css-extract-plugin
export default {"container":"CoachDashboardBento_container__qFJMx","scrollBar":"CoachDashboardBento_scrollBar__DQvOV"};